export default __webpack_public_path__ + "static/media/drone.c0be99cc.svg";